import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import React from "react";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
export type BenefitViewProps = {
  count: string;
  mode: Mode;
  text?: string | null;
  theme: Theme;
  title?: string | null;
};
export function BenefitView({
  count,
  mode,
  text,
  theme,
  title
}: BenefitViewProps) {
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  return <_StyledDiv $_css={[{
    "display": "flex",
    "flexDirection": "column",
    "gap": "1.6rem",
    "paddingTop": "2.4rem",
    "paddingBottom": "2.4rem",
    "@media (min-width: 1024px)": {
      "flexDirection": "row",
      "justifyContent": "space-between",
      "gap": "2.4rem"
    }
  }]}>
      <_StyledDiv2>
        <_StyledSpan $_css2={[{
        "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
        "fontSize": "1.4rem",
        "lineHeight": "1.1",
        "letterSpacing": "0.028000000000000004rem",
        "fontWeight": "400",
        "@media (min-width: 1024px)": {
          "fontSize": "1.6rem",
          "lineHeight": "1.1",
          "letterSpacing": "0.032rem",
          "fontWeight": "400"
        }
      }, themeStyle.label]}>
          {count}
        </_StyledSpan>
        <_StyledP>{title}</_StyledP>
      </_StyledDiv2>
      <_StyledP2>{text}</_StyledP2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-127qdc9-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-127qdc9-1"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "2.4rem"
});
var _StyledSpan = _styled3("span").withConfig({
  componentId: "sc-sf-127qdc9-2"
})`${p => p.$_css2}`;
var _StyledP = _styled4("p").withConfig({
  componentId: "sc-sf-127qdc9-3"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledP2 = /*#__PURE__*/_styled5("p").withConfig({
  displayName: "benefit___StyledP2",
  componentId: "sc-1oa0spd-0"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});